module.exports = __webpack_public_path__ + "static/quibi-cfbe1cc648099e047e2b7e01fb1baa5a.png";